import { SOCIAL_CALLBACK } from "constants/api";
import axios, { AxiosError } from "axios";
import { signInWithCustomToken, getAuth } from 'firebase/auth'
import { dlTrackEvent } from "components/dataLayer/dataLayer";
import Google from "components/icon/google";
import { useContext, useEffect, useState } from "react";
import { LoaderContext } from "contexts/loader-context";
import { IBodyLoginExternal } from "../auth";

const GOOGLE_SCRIPT_SRC = "https://accounts.google.com/gsi/client"

export default function GoogleSDK({ handleSubmit, setError }: { handleSubmit: ({ bodyLogin }: { bodyLogin: any; }) => Promise<void>, setError: (error: string | number) => void }) {
  const { setLoad } = useContext(LoaderContext)
  const [buttonGoogle, setButtonGoogle] = useState<{ click: () => void; }>()
  const firbaseAuth = getAuth()

  const handleClick = async (response: any) => {
    setLoad(true)
    try {
      dlTrackEvent('user_interaction', {
        action: "click",
        element: 'google',
        section: "login"
      })
      gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'Click - Google', value: 'Google' })
      const { data } = await axios.get(`${SOCIAL_CALLBACK}google/signin?code=${response?.access_token}`, {
        headers: {
          'PH-Api-ID': PH_API_ID
        }
      })
      const firebaseLogin = await signInWithCustomToken(firbaseAuth, data.firebaseAccessToken)
      const names = firebaseLogin.user?.displayName?.split(' ') || ['', '']
      const email = firebaseLogin.user?.email
      const firstName = names[0]
      const lastName = names[names.length - 1]

      const bodyLogin: IBodyLoginExternal = {
        accessToken: data?.providerAccessToken,
        firstName,
        lastName,
        email,
        provider: 'Google'
      }

      return await handleSubmit({ bodyLogin })
    } catch (error) {
      const code = (error as AxiosError).response?.data.code || 99999
      setError(code)
    } finally {
      setLoad(false)
    }
  }

  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    const existingScript = document.querySelector(`script[src="${GOOGLE_SCRIPT_SRC}"]`);
    if (existingScript) {
      setScriptLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = GOOGLE_SCRIPT_SRC;
    script.async = true;
    script.onload = () => setScriptLoaded(true);
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (!scriptLoaded) return;

    const client = (window as any).google?.accounts.oauth2.initTokenClient({
      client_id: GOOGLE_CLIENTID,
      ux_mode: "popup",
      scope: "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
      callback: handleClick,
    });

    setButtonGoogle({
      click: () => client.requestAccessToken(),
    });
  }, [scriptLoaded]);

  return (
    <>
      {
        buttonGoogle && (
          <Google className='google' onClick={() => buttonGoogle.click()} />
        )
      }
    </>
  )
}